import keyMirror from "ramda-extension/es/keyMirror";
const type = keyMirror({
    VALIDATION: null
});
const displayType = keyMirror({
    FIELD: null,
    POPOVER: null
});
const origin = keyMirror({
    FE: null,
    BE: null
});
const severity = keyMirror({
    ERROR: null,
    REQUIRED: null,
    WARNING: null
});
export const REDUCER_NAME = 'globalErrors';
export default {
    type,
    displayType,
    origin,
    severity
};
